import { InjectionToken } from '@angular/core';

export const frenchDays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export const shortFrenchDays = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven'];

export const shortFrenchDaysComplete = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];

export const NURSE = 'Infirmiere';

export const DEMANDE_RH = 'demande-rh';

export const SURGEON = 'Chirurgien';

export const NURSE_TYPES = [
  'Infirmiere',
  'IDE',
  'IBODE',
  'IDE SSPI',
  'IDE Perfusionniste',
  'AS',
  'AS Endoscopie',
  'Manipulateur',
  'Autres',
  'Eleve',
  'IDE MT',
  'VAE',
  'MED',
  'MAD',
];

export const NOT_NURSES = ['Anesthésiste', 'iade', 'Iade', 'IADE', 'Chirurgien', 'Cadre de bloc'];

export const ANESTHETIST = 'Anesthésiste';

export const ONLY_ANESTH = 'anesth';

export const Iade = 'Iade';

export const ANESTHESIST_WITH_ACCENT = 'Anesthesiste';

export const COMMISSION_REGULATION = 'commission-regulation';

export const CAMPAIGNS = 'campaigns';

export const VACATAIRE = 'Vacataire';

export const TITULAIRE = 'Titulaire';

export const IADE = ['Iade', 'IADE', 'iade'];

export const ANESTHETIST_TYPES = [ANESTHETIST, ...IADE];

export const SENIOR = 'Senior';

export const JUNIOR = 'Junior';

export const INTERN = 'Interne';

export const FORBIDDEN_SPECIALTIES = ['Bariatrique'];

export const NURSE_MORNING_SHIFT_END_TIME = '14:00';

export const NURSE_AFTERNOON_SHIFT_START_TIME = '14:00';

export const HOSPITAL_END_TIME = '19:00';

export const HOSPITAL_START_TIME = '08:00';

export const INTERVENTION_START_TIME = '08:30';

export const INTERVENTION_END_TIME = '19:00';

export const CYCLEDURATIONS = [...Array(30).keys()].map((i: number) => i + 1);

export const ONHOLD = 'ONHOLD';

export const APPROVED = 'APPROVED';

export const PROFILES_ON_GARDE = 'profilesOnGarde';

export const PROFILES_ON_PROGRAMS = 'profilesOnPrograms';

export const CONFIRMATION_MESSAGE = `Vous êtes sur le point de quitter la page et vous avez des modifications en cours qui ne sont pas sauvegardées. En quittant sans sauvegarder, vous perdrez toute vos modifications`;

export const CONFIRMATION_MESSAGE_VALIDATE =
  'Vous avez commencé une action de validation des programmes. Vous pouvez valider ces modifications, les ignorer, ou continuer votre édition.';

export const components = {
  INFIRMIER_COMPONENT: 'InfirmierComponent',
  SURGEON_COMPONENT: 'SurgeonOpeningsComponent',
  ANE_COMPONENT: 'HrsuiteAnesthesisteComponent',
  ANE_NEEDS_COMPONENT: 'anesthNeedsComponent',
  SP_COMPONENT: 'SmartPlanningComponent',
  RECAP_COMPONENT: 'DayProgramRecapComponent',
  SURGEON_ROOM_COMPONENT: 'SurgeonComponent',
  SURGEON_OPENINGS_ROOMS_COMPONENT: 'SurgeonOpeningsRoomsComponent',
  PER_INTERVENTIONS_COMPONENT: 'PerInterventionsComponent',
  RECOVERY_ROOM_COMPONENT: 'RecoveryRoomComponent',
};

export const DATE_WEEK = 'DATE_WEEK';

export const DATE_DAY = 'DATE_DAY';

export const DATE_FROM = 'DATE_FROM';

export const DATE_TO = 'DATE_TO';

export const COMMISSION_REGULATION_TITLE = 'Commission de régulation';

export const CADRE_DE_BLOC = 'Cadre de bloc';

export const DELETED_PROGRAMS = 'deletedPrograms';

export const TOPICS = {
  CALENDAR: 'calendar',
  VACATIONS: 'vacations',
  SMART_BRIEF: 'smart-brief',
  PARCOURS_IBODE_REQUEST: 'parcours-ibode-request',
  PARCOURS_IBODE_RECAP: 'nurse-course',
  PROGRAM: 'program',
  MESSAGERIE: 'messagerie',
  STATOP: 'statop',
  UPDATE_STORE: 'update-store',
};

export const BLOC = 'BLOC';

export const CONSULTATION = 'CONSULTATION';

export const MIN_PASSWORD_LENGTH: number = 12;

export const VALID_PASSWORD_LENGTH: number = 4;

export const PASSWORD_STANDARDS: string[] = [
  'Doit contenir au moins 12 caractères',
  'Doit contenir une lettre minuscule',
  'Doit contenir une lettre majuscule',
  'Doit contenir un chiffre',
  'Doit contenir un caractère spécial',
];

export const OPTIONS = {
  PROGRAMS_DATA_PIPELINE: 'PROGRAMS_DATA_PIPELINE',
  VACATIONS_DATA_PIPELINE: 'VACATIONS_DATA_PIPELINE',
  CALENDARS_DATA_PIPELINE: 'CALENDARS_DATA_PIPELINE',
  TRANSFORM_DA_INTO_SO: 'TRANSFORM_DA_INTO_SO',
  STATS_CUSTOMIZATION: 'STATS_CUSTOMIZATION',
  IADES_NEEDS_MORNING_AFTERNOON: 'IADES_NEEDS_MORNING_AFTERNOON',
};

export const WEIGHT = {
  SENIOR: 1,
  JUNIOR: 1,
  INTERN: 0,
};

export const diminutifLength = 3;

export const OVERFLOW_THRESHOLD = 30 * 60 * 1000;

export const FALLBACK_IMAGE =
  'data:image/svg+xml;base64,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';

export const FULLSCREEN_REFRESH_INTERVAL = 5 * 60 * 1000;

export const INSTANCE_ID = new InjectionToken<string>('instance-id', {
  factory: () => crypto.randomUUID(),
});
